require('../../brokerPensionPlanContribution.scss');
require('./pensionPlanPeriodicStep1.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ components
const { AmountInput } = require('commonsComponents/amountInput');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKMessage } = require('commonsComponents/OKMessage');

const BrokerHireAndContributionsModal = require('components/broker/brokerHireAndContributionsModal/brokerHireAndContributionsModal');
// @ constants
const language = getLanguage();
const {
    FIRST_STEP,
    BY_PORCENTAGE,
    BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_PERCENTAGE_LENGTH,
    BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_PERCENTAGE_VALUE,
    BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_AMOUNT_VALUE,
    BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_AMOUNT_LENGTH,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_VALUE,
    BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_CODE
} = require('constants/index');
const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_LOCALE,
    DATE_PICKER_CUSTOM_DATE_FORMAT
} = require('constants/commonsComponents');

class pensionPlanPeriodicStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.onHandleDateChange = this.onHandleDateChange.bind(this);
        this.handleRevAnualChange = this.handleRevAnualChange.bind(this);
        this.handlePeriodiclyMonthChange = this.handlePeriodiclyMonthChange.bind(this);
        this.onHandlePeriodiclyAmountInput = this.onHandlePeriodiclyAmountInput.bind(this);
        this.onHandlePercentageAmountInput = this.onHandlePercentageAmountInput.bind(this);
    }

    componentDidMount() {
        this.props.setPeriodicity(true);
        this.props.setPeriodiclyMonthly({
            value: BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_CODE,
            label: BROKER_CONTRIBUTION_PLAN_PERIODIC_MONTHLY_OPTION_MONTH_VALUE
        });
    }

    onHandleDateChange(date) {
        this.props.setValidityDate(date);
    }

    onHandlePercentageAmountInput(value) {
        this.props.setPercentagePeriodiclyAmount(value);
    }

    onHandlePeriodiclyAmountInput(value) {
        this.props.setPeriodiclyAmount(value);
    }

    getAssociatedAccountBalance(accountNumber) {
        const { immAccounts } = this.props;
        const selectedAccount = immAccounts.get('byId').find(account =>
            account.getIn(['ibanComplex', 'codbban']) === accountNumber
        );

        return {
            amount: selectedAccount ? selectedAccount.getIn(['balances', 'availableBalance', 'amount']) : '',
            currency: selectedAccount ? selectedAccount.getIn(['balances', 'availableBalance', 'currency']) : ''
        };
    }

    buildPeriodiclyDropDown() {
        const { immPensionPlanContribution } = this.props;
        const months = immPensionPlanContribution.getIn(['steps', FIRST_STEP, 'periodiclyMonthlyOptions']);
        const processedMonths = months.map((entry, index) =>
            entry.merge({ value: index, label: entry.get('label') })
        );
        return processedMonths.toJS();
    }

    buildRevValuesDropDown() {
        const { immPensionPlanContribution } = this.props;
        const revValues = immPensionPlanContribution.getIn(['steps', FIRST_STEP, 'revAnualOptions']);
        const processedRevValues = revValues.map((entry, index) =>
            entry.merge({ value: index, label: entry.get('label') })
        );
        return processedRevValues.toJS();
    }

    createAnualRev(step1, errors) {
        return (
            <span className="broker-pension-plan-periodic-contribution-step1__rev-anual">
                <OKSelect
                    label={formatText('pensionPlanContribution-step1AnualRev')}
                    onChange={this.handleRevAnualChange}
                    options={this.buildRevValuesDropDown()}
                    value={step1.get('revAnual')}
                    autosize={false}
                    placeholder={formatText('pensionPlanContribution-step1MonthlyPlaceHolder')}
                    errorState={errors.get('revAnualError')}
                    errorMessage={formatText('pensionPlanContribution-revAnnualError')}
                    searchable={false}
                />
            </span>
        );
    }

    createDatePicker(step1, isEditMode) {
        const { immPensionPlanPeriodicalContribution } = this.props;
        const minDate = immPensionPlanPeriodicalContribution.get('minDate');

        return (
            <span className="broker-pension-plan-periodic-contribution-step1__date-picker">
                <DatePickerCustom
                    callback={this.onHandleDateChange}
                    selectedDate={step1.get('validityDate')}
                    label={formatText('pensionPlanContribution-step1PeriodiclyDateLabel')}
                    placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                    locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                    dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                    disabled={isEditMode}
                    minDate={minDate}
                />
                <FormattedText
                    className="broker-pension-plan-periodic-contribution-step1__disable-hour"
                    value="pensionPlanContribution-disableHour" // disableHour
                />
                <FormattedText
                    className="broker-pension-plan-periodic-contribution-step1__peninsular-schedule"
                    value="pensionPlanContribution-peninsularSchedule" // peninsularSchedule
                />
            </span>
        );
    }

    createMinimalAmountLabel(balance) {
        const { immPensionPlanContribution } = this.props;
        const periodicity = immPensionPlanContribution.getIn(['steps', FIRST_STEP]).get('periodiclyLabel');
        const plainAmountObject = getPlainAmountObject(balance);

        return (
            <div className="broker-pension-plan-periodic-contribution-step1__associated-cc-minimal">
                <FormattedText
                    value="pensionPlanContribution-minimalWithParameter"
                    injectedStrings={[periodicity]}
                />
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
            </div>
        );
    }

    createMonthlyDropdown(step1, errors) {
        const { immPensionPlanContribution } = this.props;
        const isEditMode = immPensionPlanContribution.get('isEditMode');
        const classWithoutDate = classNames({
            '--without-date': isEditMode
        });

        return (
            <div className={`broker-pension-plan-periodic-contribution-step1__select${classWithoutDate}`}>
                <OKSelect
                    label={formatText('pensionPlanContribution-step1PeriodiclyMonthlyLabel')}
                    onChange={this.handlePeriodiclyMonthChange}
                    options={this.buildPeriodiclyDropDown()}
                    value={step1.get('periodiclyMonthlyValue')}
                    autosize={false}
                    placeholder={''}
                    errorState={errors.get('periodiclyMonthlyError')}
                    errorMessage={''}
                    searchable={false}
                />
            </div>
        );
    }

    createPercentage(step1) {
        const { immPensionPlanContribution } = this.props;
        let percentageInput;
        if (immPensionPlanContribution.getIn(['steps', FIRST_STEP, 'isPercentageInputAvailable'])) {

            const isPeriodiclyPercentageError = step1.getIn(['errors', 'periodiclyPercentageError']);
            const isPeriodiclyPercentageEmpty = step1.getIn(['errors', 'periodiclyPercentageEmpty']);
            const revAnual = step1.get('revAnual');

            let errorMessage
            if (isPeriodiclyPercentageError) {
                errorMessage = formatText('pensionPlanContribution-percentageOutOfLimits');
            }
            if (isPeriodiclyPercentageEmpty) {
                errorMessage = formatText('pensionPlanContribution-errorEmptyPercentage');
            }

            percentageInput = (
                <span className="broker-pension-plan-periodic-contribution-step1__amount">
                    <AmountInput
                        maxFractionLength={BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_PERCENTAGE_VALUE}
                        maxBackEndFractionLength={BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_PERCENTAGE_VALUE}
                        maxIntegerLength={BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_PERCENTAGE_LENGTH}
                        error={isPeriodiclyPercentageError || isPeriodiclyPercentageEmpty}
                        hideFocusZero={true}
                        errorMsg={errorMessage}
                        amount={revAnual.importeOPorcentajeRevalorización}
                        callback={this.onHandlePercentageAmountInput}
                        label={formatText('pensionPlanContribution-step1PercentageAmountLabel')}
                        language={language}
                    />
                </span>
            );
        }
        return percentageInput;
    }

    createPeriodiclyAmount(step1, errors, amount) {
        const minimalText = this.createMinimalAmountLabel(amount);
        const periodiclyAmountError = errors.get('periodiclyAmountError');
        const periodiclyAmountOverLimitError = errors.get('periodiclyAmountOverLimitError');
        let errorMessage;
        if(periodiclyAmountError) {
            errorMessage = formatText('pensionPlanContribution-amountError');
        }
        if(periodiclyAmountOverLimitError) {
            errorMessage = formatText('brokerHirePlansStep1-contributionOverLimitError');
        }
        return (
            <span className="broker-pension-plan-periodic-contribution-step1__amount">
                <AmountInput
                    min={0}
                    amount={step1.get('periodiclyAmount')}
                    callback={this.onHandlePeriodiclyAmountInput}
                    error={periodiclyAmountError || periodiclyAmountOverLimitError}
                    errorMsg={errorMessage}
                    label={formatText('pensionPlanContribution-step1AmountLabel')}
                    language={language}
                    maxFractionLength={BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_AMOUNT_VALUE}
                    maxBackEndFractionLength={BROKER_CONTRIBUTION_PLAN_FRACTION_LENGTH_AMOUNT_VALUE}
                    maxIntegerLength={BROKER_CONTRIBUTION_PLAN_MAXIMUN_INTEGER_AMOUNT_LENGTH}
                    hideFocusZero
                />
                {minimalText}
            </span>
        );
    }

    handlePeriodiclyMonthChange(value) {
        this.props.setPeriodiclyMonthly(value);
    }

    handleRevAnualChange(value) {
        const percentageInputAvailable = value.label === BY_PORCENTAGE;
        this.props.setAvailablePercentageInput(percentageInputAvailable);
        this.props.setRevAnual(value);
    }

    render() {
        const { immPensionPlanContribution, immBrokerPensionPlans } = this.props;
        const step1 = immPensionPlanContribution.getIn(['steps', FIRST_STEP]);
        const isEditMode = immPensionPlanContribution.get('isEditMode');
        const errors = step1.get('errors');
        const walletPlan = immPensionPlanContribution.get('pensionPlanFromWallet');

        const balanceForMinimal = {
            amount: step1.get('periodicityMinimum'),
            currency: immBrokerPensionPlans.getIn(['pensionPlan', 'contributionMinimumAmountCurrency'])
        };

        let associatedAccountNumber = '';
        if (walletPlan) {
            const associatedAccount = walletPlan.get('cuentaAsociada');
            const office = associatedAccount.get('oficina');
            associatedAccountNumber = office.get('entidad') + office.get('oficina') + associatedAccount.get('digitodecontrol') + associatedAccount.get('numerodecuenta');
        }

        const pensionPlanProvider = immBrokerPensionPlans.getIn(['pensionPlan', 'provider']);
        const truncatedAccountNumber = associatedAccountNumber.substr(associatedAccountNumber.length - 4);
        const balance = this.getAssociatedAccountBalance(associatedAccountNumber);
        const plainAmountObject = getPlainAmountObject(balance);

        let initDate;
        if( !isEditMode ) {
            initDate = this.createDatePicker(step1, isEditMode);
        }

        const periodiclyInputs = (
            <div className="broker-pension-plan-periodic-contribution-step1__periodicly-box">
                <div className="hire-pension-plan-step1__disclaimer-container">
                    <OKMessage>
                        <FormattedText value="brokerHirePlansStep1-contributionBoxSubtitle" />
                    </OKMessage>
                </div>
                <div>
                    {initDate}
                    {this.createMonthlyDropdown(step1, errors)}
                    {this.createPeriodiclyAmount(step1, errors, balanceForMinimal)}
                </div>
                <h2 className="broker-pension-plan-contribution__subtitle">{formatText('pensionPlanContribution-step1PeriodiclySection')}</h2>
                <div>{this.createAnualRev(step1, errors)}{this.createPercentage(step1)}</div>
            </div>
        );

        return (
            <article className="broker-pension-plan-contribution broker-pension-plan-periodic-contribution-step1">
                <header className="broker-pension-plan-contribution__header">
                    <FormattedText
                        value="pensionPlanContribution-step1Title"
                        className="broker-transfer-external-steps__title"
                    />
                </header>
                <section className="broker-pension-plan-contribution__content">
                    <div>
                        <BrokerHireAndContributionsModal pensionPlanProvider={pensionPlanProvider}/>
                        <p>
                            <FormattedText
                                value="pensionPlanContribution-step1AssociatedAccountLabel"
                                className="broker-pension-plan-periodic-contribution-step1__associated-account"
                            />
                        </p>
                        <p>
                            <span className="broker-pension-plan-periodic-contribution-step1__associated-account-name">
                                {immPensionPlanContribution.getIn(['pensionPlanFromWallet', 'descripcion'])}
                            </span>
                            <span className="broker-pension-plan-periodic-contribution-step1__associated-account-name--extra">
                                {' '}...{truncatedAccountNumber} ({formatText('pensionPlanContribution-associatedAccountText')}
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />)
                            </span>
                        </p>
                        <h2 className="broker-pension-plan-periodic-contribution-step1__informative-text">{formatText('pensionPlanContribution-informativeText')}</h2>
                        <div className="broker-pension-plan-contribution__group-div">
                            {periodiclyInputs}
                        </div>
                    </div>
                </section>
            </article>
        );
    }
}

pensionPlanPeriodicStep1.propTypes = {
    immPensionPlanContribution: PropTypes.object.isRequired,
    immPensionPlanPeriodicalContribution: PropTypes.object.isRequired,
    immBrokerPensionPlans: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    setOriginalAmount: PropTypes.func.isRequired,
    setPeriodicity: PropTypes.func.isRequired,
    setPeriodiclyMonthly: PropTypes.func.isRequired,
    setRevAnual: PropTypes.func.isRequired,
    setPeriodiclyAmount: PropTypes.func.isRequired,
    setValidityDate: PropTypes.func.isRequired,
    setAvailablePercentageInput: PropTypes.func.isRequired,
    setPercentagePeriodiclyAmount: PropTypes.func.isRequired,
};

module.exports = pensionPlanPeriodicStep1;
